import { LineSkeletonStyled } from 'components/base/Skeletons';

const LineLoader = () => {
  return <LineSkeletonStyled style={{ width: '25rem', height: '3rem' }} />;
};

export default LineLoader;
